import React, { useEffect } from 'react'
import { RouteComponentProps, useLocation, useHistory } from 'react-router-dom';
import { useGlobal, useDispatch } from 'reactn';
import IForfettariAppBar from '../../appBar/IForfettariAppBar';
import Main from '../../components/main';
import { Agency } from '../../models/agency';
import { IGlobalState, InEditingMode } from '../../states/GlobalState';
import AgencyEdit from './edit';

type PageEditAgencyProps = RouteComponentProps<any>;

export const AgencyDetail = (props: PageEditAgencyProps) => {
    const dispatch = useDispatch();
    const location = useLocation();
    const history = useHistory();
    const [currentEditAgency] = useGlobal<IGlobalState, 'currentEditAgency'>('currentEditAgency');
    const oidIndex = location.pathname.lastIndexOf('/')
    const oid = parseInt(location.pathname.substring(oidIndex + 1))
    
    //TODO
    console.log('Agency id is: ' + oid);
    const agency = currentEditAgency?.agency;

    useEffect(() => {
        // Il seguente è per non eseguire cambio di pagina durante il render
        if(!agency) 
            history.push('/agency');
    }, [agency, history])

    const initialMode = oid > 0 ? InEditingMode.Edit : InEditingMode.New;
    return ( 
        <div style={{ backgroundColor: "#e3e3e3", minHeight: "100vh" }}>
            <IForfettariAppBar title="Agency" handleLoad={() => {}}></IForfettariAppBar>
            <Main>
                <AgencyEdit initialMode={initialMode} /> 
            </Main>
        </div>    
    )
}




